<template>
  <div class="ItemList_empty">
    <img alt="Search Not Found" :src="art">
    <h3>{{message}}</h3>
  </div>
</template>

<script>
  export default {
    name: "NoInvoice",
    props:{
      message: ''
    },
    data() {
      return {
        art: `https://seagm-media.seagmcdn.com/mini_store/${process.env.VUE_APP_ART_PATH}/search.png?x-oss-process=image/resize,w_480`
      }
    }
  }
</script>

<style>
</style>
